import type { FC } from "react";

import { cn } from "@/ui/lib";
import { Separator } from "@/ui/components/primitives/Separator";
import {
  TItemSeparatorProps,
} from "@/ui/components/data-display/Item/Item.config";

export const ItemSeparator: FC<TItemSeparatorProps> = (
  {
    className,
    ...props
  },
) => (
  <Separator
    {...props}
    data-component="ItemSeparator"
    className={cn("border-muted", className)}
  />
);

ItemSeparator.displayName = "ItemSeparator";
